import { render, staticRenderFns } from "./Movies.vue?vue&type=template&id=0b2fcafb&scoped=true"
import script from "./Movies.vue?vue&type=script&lang=js"
export * from "./Movies.vue?vue&type=script&lang=js"
import style0 from "./Movies.vue?vue&type=style&index=0&id=0b2fcafb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2fcafb",
  null
  
)

export default component.exports